// eslint-disable-next-line import/no-extraneous-dependencies
import {Request, Response} from 'express';
import {HEART_BEAT_PUBLIC_ROUTE} from './constants';

export const createHeartBeatMiddleware = async (
  _req: Request,
  res: Response,
) => {
  res.status(200).json({
    requestReceivedAt: new Date().toISOString(),
  });
};

createHeartBeatMiddleware.PUBLIC_ROUTE = HEART_BEAT_PUBLIC_ROUTE;
